<template>
  <div class="main">
    <div class="container">
      <div class="header">
        <router-link :to="{name: 'home'}">
          <el-button type="primary" class="back-button" icon="el-icon-back"></el-button>
        </router-link>
      </div>
      <div class="content">
        <h2>Wichtelgruppe erstellen</h2>
        <span class="input-label">Name der Wichtelgruppe</span>
        <el-input v-model="project.name" placeholder="Name der Wichtelgruppe"></el-input>

        <span class="input-label">Maximale Anzahl der Benutzer</span>
        <el-input type="number" v-model="project.max_users" placeholder="Maximale Anzahl der Benutzer"></el-input>

        <span class="input-label">E-Mail des Admins</span>
        <el-input type="email" v-model="project.email" placeholder="E-Mail des Admins"></el-input>

        <el-button v-on:click="createProject" type="primary" class="create-button" round>Wichtelgruppe erstellen</el-button>
      </div>
    </div>
    <el-dialog title="Gruppe erfolgreich erstellt" :visible.sync="centerDialogVisible" center>
      <span>Die Gruppe wurde erfolgreich erstellt. Als Administrator der Gruppe bist du standardmäßig noch nicht als Teilnehmer hinterlegt.</span>
      <span> Wenn du der Gruppe als Teilnehmer beitreten möchtest, bestätige den Dialog bitte mit 'Gruppe beitreten'.</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">OK</el-button>
        <el-button type="primary" @click="showJoinPage">Gruppe beitreten</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ProjectService from "../services/ProjectService.js";

export default {
  name: "CreateProject",
  props: {},
  data() {
    return {
      project: {
        name: "",
        max_users: 0,
        email: ""
      },
      centerDialogVisible: false
    };
  },
  created() {},
  methods: {
    createProject() {
      ProjectService.createProject(this.project).then(createdProject => {
        this.project = createdProject;
        ProjectService.addProjectToLocalStorage(
          createdProject.encryptedKey,
          "admin"
        );
        this.centerDialogVisible = true;
      });
    },
    showJoinPage() {
      this.centerDialogVisible = false;
      this.$router.push({
        name: "join-project",
        params: { id: this.project.id }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.main {
  .el-input {
    width: 275px;
  }

  .input-label {
    margin-top: 20px;
  }

  .create-button {
    margin-top: 25px;
    min-height: 40px;
  }
}
</style>
